<template>
  <div class="add-task-dialog">
    <v-form ref="form">
      <!-- STEP 1 : TITLE -->
      <v-stepper class="my-steper" v-model="e6" vertical>
        <v-card-title v-if="editedTask">
          {{ $t("addTaskCard.Update") }} #{{ editedTask.details.id }}
        </v-card-title>
        <v-card-title v-else>
          {{ $t("addTaskCard.create") }}
        </v-card-title>

        <v-stepper-step
          :editable="value.title != null"
          :complete="value.title != null"
          step="1"
        >
          {{ $t("addTaskCard.title") }}
        </v-stepper-step>

        <v-stepper-content step="1">
          <div>
            <v-card-text>
              <v-textarea
                id="title-add-task"
                :label="$t('addTaskCard.title')"
                rows="1"
                row-height="30"
                v-model="value.title"
                :clearable="true"
                filled
              ></v-textarea>
            </v-card-text>
          </div>
          <v-card-actions>
            <v-btn
              :disabled="!value.title"
              color="primary"
              @click="e6 = 2"
              class="next-add-event"
            >
              {{ $t("addEventCard.next") }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn plain text color="secondary" @click="closeEvent">
              {{ $t("addEventCard.cancel") }}
            </v-btn>
          </v-card-actions>
        </v-stepper-content>

        <!-- STEP 2 : DATES  -->
        <v-stepper-step
          :editable="value.endDate != null || value.beginDate != null"
          :complete="value.endDate != null || value.beginDate != null"
          step="2"
        >
          {{ $t("addEventTask.dates") }}
        </v-stepper-step>

        <v-stepper-content step="2">
          <div>
            <v-row>
              <!-- date picker 1 -->
              <v-col cols="12" sm="6" md="6">
                <v-menu
                  v-model="datePickerStart"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-card-text>
                      <v-text-field
                        id="datepicker-start-add-event"
                        v-model="value.beginDate"
                        :label="$t('addEventCard.dateStart')"
                        prepend-icon="mdi-calendar"
                        :rules="emptyField"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </v-card-text>
                  </template>

                  <v-date-picker
                    v-model="value.beginDate"
                    :max="value.endDate"
                    :locale="this.$i18n.locale"
                    @input="datePickerStart = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <!-- date picker 2 -->
              <v-col cols="12" sm="6" md="6">
                <v-menu
                  v-model="datePickerEnd"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-card-text>
                      <v-text-field
                        id="datepicker-end-add-event"
                        v-model="value.endDate"
                        :label="$t('addEventCard.dateEnd')"
                        prepend-icon="mdi-calendar"
                        :rules="emptyField"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </v-card-text>
                  </template>

                  <v-date-picker
                    v-model="value.endDate"
                    :locale="this.$i18n.locale"
                    :min="value.beginDate"
                    @input="datePickerEnd = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </div>
          <v-card-actions>
            <v-btn
              class="next-add-event"
              :disabled="!value.beginDate || !value.endDate"
              color="primary"
              @click="e6 = 3"
            >
              {{ $t("addEventCard.next") }}
            </v-btn>
            <v-btn text @click="e6 = 1">
              {{ $t("addEventCard.back") }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn plain text color="secondary" @click="closeEvent">
              {{ $t("addEventCard.cancel") }}
            </v-btn>
          </v-card-actions>
        </v-stepper-content>

        <!-- STEP 3 : Employee -->
        <v-stepper-step
          :editable="value.user != null"
          :complete="value.user != null"
          step="3"
        >
          {{ $t("addTaskCard.Employee") }} ({{ $t("addTaskCard.Optional") }})
        </v-stepper-step>

        <v-stepper-content step="3">
          <div>
            <v-row>
              <v-col cols="24" lg="12" xl="12">
                <v-card-text>
                  <v-autocomplete
                    id="users-add-event"
                    :items="users"
                    item-text="fullname"
                    item-value="id"
                    :label="$t('addEventCard.employee')"
                    persistent-hint
                    single-line
                    v-model="userFieldId"
                    :clearable="true"
                    filled
                  ></v-autocomplete>
                </v-card-text>
              </v-col>
            </v-row>
          </div>
          <v-card-actions>
            <v-btn class="next-add-event" color="primary" @click="e6 = 4">
              {{ $t("addEventCard.next") }}
            </v-btn>
            <v-btn text @click="e6 = 2">
              {{ $t("addEventCard.back") }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn plain text color="secondary" @click="closeEvent">
              {{ $t("addEventCard.cancel") }}
            </v-btn>
          </v-card-actions>
        </v-stepper-content>

        <!-- STEP 4 : Intervention -->
        <v-stepper-step
          :editable="value.intervention != null"
          :complete="value.intervention != null"
          step="4"
        >
          {{ $t("addTaskCard.Intervention") }} ({{
            $t("addTaskCard.Optional")
          }})
        </v-stepper-step>

        <v-stepper-content step="4">
          <div>
            <v-row>
              <v-col cols="24" lg="12" xl="12">
                <v-card-text>
                  <v-autocomplete
                    id="intervention-add-event"
                    :items="events"
                    item-value="details.id"
                    item-text="titleForChoosing"
                    :label="$t('addTaskCard.Intervention')"
                    persistent-hint
                    single-line
                    :clearable="true"
                    filled
                    v-model="interventionFieldId"
                  >
                    <template #item="{ item, on, attrs }">
                      <v-list-item v-on="on" v-bind="attrs">
                        <v-list-item-content
                          class="list-item-content"
                          :style="{ backgroundColor: item.color }"
                        >
                          <v-list-item-title class="list-item-title">
                            {{ item.location }} - {{ item.x }} -
                            {{ item.course }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </v-card-text>
              </v-col>
            </v-row>
          </div>
        </v-stepper-content>

        <v-card-actions>
          <v-btn color="success" @click="addTask" id="create-add-event">
            <div v-if="this.isEditing">
              {{ $t("addEventCard.update") }}
            </div>
            <div v-else>
              {{ $t("addEventCard.create") }}
            </div>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn plain text color="secondary" @click="closeEvent">
            {{ $t("addEventCard.cancel") }}
          </v-btn>
        </v-card-actions>

        <div v-if="errors">
          <ul class="errorsAdd">
            <li v-for="e in errorBackend" :key="e.valueE">{{ e.valueE }}</li>
          </ul>
        </div>
      </v-stepper>
    </v-form>
  </div>
</template>

<script>
import EventInfoCardVue from "@/components/components-planning/public/calendar/grid-scheduler/event-details/EventInfoCard.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    EventInfoCardVue,
  },
  props: {
    editedTask: null,
  },
  data() {
    return {
      e6: 1,
      datePickerStart: false,
      datePickerEnd: false,
      isEditing: false,
      hasSaved: false,
      errors: false,
      value: {
        id: 0,
        taskIdDg2: null,
        title: null,
        intervention: null,
        user: null,
        slug: null,
        beginDate: null,
        endDate: null,
        duration: null,
        version: null,
      },
      userFieldId: null,
      interventionFieldId: null,
      events: [],
      interventionTemp: null,
      userTemp: null,
      resultTaskUpdated: null,
      emptyField: [(v) => !!v || this.$t("errorFrontEnd.requiredField")],
      inputText: [
        (v) => !!v || this.$t("errorFrontEnd.requiredField"),
        (v) =>
          /^[ A-Za-z0-9_@./#&+-:()]*$/.test(v) ||
          this.$t("errorFrontEnd.specialCharacters"),
      ],
    };
  },
  computed: {
    ...mapGetters("userModule", { users: "getUsersForm" }),
    ...mapGetters("eventModule", { eventsForUser: "getEventsByUserAfterDate" }),
    ...mapGetters("notificationModule", { errorBackend: "getErrorBackend" }),
  },
  watch: {
    editedTask: function () {
      this.setupDataForCard();
    },
    userFieldId: async function () {
      if (this.userFieldId != null) {
        await this.getAllInterventionsByUserIdAfterDate({
          userId: this.userFieldId,
          dateStart: this.value.beginDate,
        })
          .then((this.events = this.eventsForUser))
          .then(
            this.events.forEach((element) => {
              element.titleForChoosing =
                element.location + " - " + element.x + " - " + element.course;
            })
          );
      } else {
        this.events = [];
      }
    },
  },
  mounted() {
    this.setupDataForCard();
  },
  methods: {
    ...mapActions("taskModule", [
      "editTask",
      "createTask",
      "getTaskById",
      "setSelectedTask",
    ]),
    ...mapActions("eventModule", [
      "getAllInterventionsByUserIdAfterDate",
      "setEventSelected",
    ]),
    ...mapActions("notificationModule", ["emptyErrorMessages"]),

    async setupDataForCard() {
      if (this.editedTask != null) {
        this.value = this.frontTaskToTaskDto(this.editedTask);
        this.isEditing = true;
        if (this.value.user != null) {
          this.userFieldId = this.value.user.id;
          if (this.value.intervention != null) {
            this.interventionFieldId = this.value.intervention.id;
          }
          await this.getAllInterventionsByUserIdAfterDate({
            userId: this.value.user.id,
            dateStart: this.value.beginDate,
          })
            .then((this.events = this.eventsForUser))
            .then(
              this.events.forEach((element) => {
                element.titleForChoosing =
                  element.dateStart + " - " + element.course.title;
              })
            );
        }
      } else {
        this.isEditing = false;
      }
    },

    frontTaskToTaskDto(task) {
      return {
        id: task.details.id,
        taskIdDg2: task.details.taskIdDg2,
        title: task.details.title,
        intervention: task.details.intervention,
        user: task.details.user,
        slug: task.details.slug,
        beginDate: task.details.beginDate,
        endDate: task.details.endDate,
        duration: task.details.duration,
        version: task.details.version,
      };
    },
    async addTask() {
      this.emptyErrorMessages(); // when close by clicking on the side
      this.errors = false;

      this.userTemp = this.users.find((u) => u.id === this.userFieldId);
      this.interventionTemp = this.events.find(
        (e) => e.details.id === this.interventionFieldId
      );

      if (this.userTemp) {
        this.value.user = this.userTemp.details;
      }

      if (this.interventionTemp) {
        this.value.intervention = this.interventionTemp.details;
      }

      if (this.editedTask != null) {
        await this.editTask(this.value);
        if (this.errorBackend.length === 0) {
          this.closeEvent();
        } else {
          this.errors = true;
          this.e6 = 1;
        }
      } else {
        this.createTask(this.value).then((e) => {
          if (this.errorBackend.length === 0) {
            this.closeEvent();
          } else {
            this.errors = true;
            this.e6 = 1;
          }
        });
      }
    },
    async closeEvent() {
      this.setSelectedTask(this.value.id);
      this.value = {};
      this.$refs.form.reset();
      this.errors = false;
      this.e6 = 1;
      this.emptyErrorMessages();
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss">
.add-task-dialog {
  border-radius: 50px;
  height: 100%;
  overflow: auto;

  .v-form {
    .my-steper {
      height: 100%;
      background: none;
      box-shadow: none;

      .v-card__title {
        text-align: center;
        justify-content: center;
        color: white;
        background-color: #1975d2;
      }
    }
  }

  button {
    margin: 0 10px 0 0;
  }
}

.list-item-content {
  border-bottom: 1px solid rgb(79, 78, 78);
}

.list-item-title {
  color: white;
  font-weight: bold;
  padding: 5px 10px;
}

.errorsAdd {
  color: red;
  list-style-type: none;
}
</style>
